import { POST } from "../../index";
export const selectAllTerminalType = (param) => POST("/v1/TerminalType/selectAllTerminalType", param);
export const insertTerminalType = (param) => POST("/v1/TerminalType/insertTerminalType", param);
export const deleteTerminalType = (param) => POST("/v1/TerminalType/deleteTerminalType", param);
export const selectAliKey = (param) => POST("/v1/TerminalType/selectAliKey", param);
export const insertAliKey = (param) => POST("/v1/TerminalType/insertAliKey", param);
export const deleteAliKey = (param) => POST("/v1/TerminalType/deleteAliKey", param);